import './CardV2Component.scss';
import React from "react";
import LinkComponent from "../link/LinkComponent";

interface CardV2Props {
    title: string;
    actionTitle?: string;
    description?: any;
    className?: string;
    onClick?: () => void;
    showAction?: boolean;
}


const CardV2Component = (props: React.PropsWithChildren<CardV2Props>) => {

    const {title, onClick, showAction, actionTitle, className, children} = props;

    return (
        <div className={`card-v2 ${className}`}>
            <div className={'ts-row'}>
                <div className={'ts-col-lg-4 ts-col-md-5 ts-col-sm-12'}>
                    <div className={'ts-col-lg-12 ts-col-md-12 card-v2__title'}>{title}</div>
                    {showAction &&
                        <div className={'ts-col-lg-12 ts-col-md-12 card-v2__actions'}>
                            <LinkComponent onClick={onClick}>({actionTitle})</LinkComponent>
                        </div>

                    }
                </div>
                <div className={'ts-col-lg-8 ts-col-md-7 ts-col-sm-12'}>
                    {
                        (React.Children.count(children)) > 0 && <div className="card-body">
                            {children}
                        </div>
                    }
                </div>
            </div>

        </div>
    )

}

export default CardV2Component;
